import { render, staticRenderFns } from "./NewsHome.vue?vue&type=template&id=6920ecd8&"
import script from "./NewsHome.vue?vue&type=script&lang=js&"
export * from "./NewsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports